import { useState, Fragment } from "react";
import secureLocalStorage from "react-secure-storage";
import BTDialogBox from "../../components/BTDialgBox";
import {
  Grid2 as Grid,
  FormControlLabel,
  Switch,
  CircularProgress,
} from "@mui/material";
import { Notifications } from "@mui/icons-material";
import BTTypography from "../../components/BTTypography";
import BTBox from "../../components/BTBox";
import BTBadge from "../../components/BTBadge";
import BTInput from "../../components/BTInput";
import { roles } from "../../dropdownData";
import authService from "../../services/auth-service";
import { useNotification } from "../../context";
const Profile = ({ open, closeProfile }) => {
  const userdata = secureLocalStorage?.getItem("userdata");
  const [edite, setEdite] = useState(false);
  const [formValues, setFormValues] = useState({
    cmp_name: userdata?.u_profile?.cmp_name || null,
    cmp_addr_line1: userdata?.u_profile?.cmp_addr_line1 || null,
    cmp_addr_line2: userdata?.u_profile?.cmp_addr_line2 || null,
    cmp_pincode: userdata?.u_profile?.cmp_pincode || null,
    cmp_city: userdata?.u_profile?.cmp_city || null,
    cmp_ph: userdata?.u_profile?.cmp_ph || null,
    cmp_email: userdata?.u_profile?.cmp_email || null,
    cmp_gst: userdata?.u_profile?.cmp_gst || null,
    cmp_gst_rate: userdata?.u_profile?.cmp_gst_rate || null,
    cmp_pan: userdata?.u_profile?.cmp_pan || null,
    cmp_state_code: userdata?.u_profile?.cmp_state_code || null,
    bank_name: userdata?.u_profile?.bank_name || null,
    bank_acc_no: userdata?.u_profile?.bank_acc_no || null,
    bank_branch: userdata?.u_profile?.bank_branch || null,
    bank_ifsc_code: userdata?.u_profile?.bank_ifsc_code,
    cmp_sub: [],
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();
  const validation = (data) => {
    const {
      cmp_name,
      cmp_addr_line1,
      cmp_pincode,
      cmp_city,
      cmp_ph,
      cmp_email,
      cmp_gst,
      cmp_gst_rate,
      cmp_pan,
      cmp_state_code,
      bank_name,
      bank_acc_no,
      bank_branch,
      bank_ifsc_code,
    } = data;
    const errors = {};
    const addError = (field, message) => (errors[field] = message);
    if (!cmp_name) addError("cmp_name", "Companey name is required !");
    if (!cmp_addr_line1) addError("cmp_addr_line1", "Address 1 is required !");
    if (!cmp_pincode) addError("cmp_pincode", "Pincode is required !");
    else if (!/^[1-9][0-9]{5}$/.test(cmp_pincode))
      addError("cmp_pincode", "Invalid pincode");
    if (!cmp_city) addError("cmp_city", "City is required !");
    if (!cmp_ph) addError("cmp_ph", "Phone number is required !");
    else if (!/^\d{10}$/.test(cmp_ph))
      addError("cmp_ph", "Invalid phone number !");
    if (!cmp_email) addError("cmp_email", "Email is required!");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cmp_email))
      addError("cmp_email", "Invalid email address !");
    if (!cmp_gst) addError("cmp_gst", "Gst is required !");
    if (!cmp_gst_rate) addError("cmp_gst_rate", "Gst rate is required ! ");
    if (!cmp_pan) addError("cmp_pan", "Pan number is required !");
    if (!cmp_state_code) addError("cmp_state_code", "State code is required!");
    if (!bank_name) addError("bank_name", "Bank name is required !");
    if (!bank_acc_no) addError("bank_acc_no", "Account number is required !");
    if (!bank_branch) addError("bank_branch", "Branch name is required !");
    if (!bank_ifsc_code) addError("bank_ifsc_code", "IFSC code is required !");
    return Object.keys(errors).length > 0 ? errors : null;
  };

  const onSave = async (e) => {
    e.preventDefault();
    const checkedErrors = validation(formValues);
    if (checkedErrors) {
      setErrors(checkedErrors);
    } else {
      try {
        setLoading(true);
        const updatedData = { ...userdata, u_profile: formValues };
        const response = await authService?.update_profile({
          attributes: { user_data: updatedData },
        });

        if (response.status === 1) {
          setEdite(false);
          secureLocalStorage.setItem("userdata", {
            ...userdata,
            u_profile: response?.data?.u_profile,
          });
          addNotification({
            icon: <Notifications color="white" />,
            title: "Success!",
            message: response?.message,
            color: "success",
          });
        }
      } catch (error) {
        addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: "Somthing Went Wrong!",
          color: "error",
        });
      } finally {
        setLoading(false);
      }
    }
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
    const updatedValue = {
      ...formValues,
      [name]: value,
    };
    const newErrors = validation(updatedValue);
    if (newErrors === null) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };

  const renderField = (field) => {
    switch (field.type) {
      case "text":
        return (
          <BTInput
            fullWidth
            label={field.label}
            name={field.name}
            value={formValues[field.name] || ""}
            onChange={onChange}
            required={field.required}
            variant="standard"
            // size="small"
            error={!!errors[field.name]}
            helperText={errors[field.name]}
            {...field}
          />
        );

      default:
        return null;
    }
  };
  const formFields = [
    {
      type: "text",
      name: "cmp_name",
      label: "Company Name",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_addr_line1",
      label: "Address Line 1",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_addr_line2",
      label: "Address Line 2",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_pincode",
      label: "Postal Code",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_city",
      label: "City",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_ph",
      label: "Phone Number",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_email",
      label: "Email Address",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_gst",
      label: "GST Number",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_gst_rate",
      label: "GST Rate (%)",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_pan",
      label: "PAN Number",
      required: true,
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "cmp_state_code",
      label: "State Code",
      required: true,
      gridsize: { xs: 12, md: 6 },
    },
    {
      type: "text",
      name: "bank_name",
      required: true,
      label: "Bank Name",
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "bank_acc_no",
      required: true,
      label: "Account Number",
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "bank_branch",
      required: true,
      label: "Bank Branch",
      gridsize: { xs: 12, md: 3 },
    },
    {
      type: "text",
      name: "bank_ifsc_code",
      required: true,
      label: "IFSC Code",
      gridsize: { xs: 12, md: 3 },
    },
  ];

  return (
    <BTDialogBox
      open={open}
      fullWidth
      maxWidth={"md"}
      maxHeight={"370px"}
      minHeight={"370px"}
      onSubmit={onSave}
      close={closeProfile}
      title={
        <BTBox display={"flex"} gap={"15px"} alignItems="center">
          <BTTypography variant="button" fontWeight={"bold"}>
            Profile
          </BTTypography>
          {userdata?.u_type === 1 && (
            <FormControlLabel
              control={
                <Switch
                  checked={edite}
                  onChange={() => setEdite(!edite)}
                  color="secondary"
                  size="small"
                />
              }
              label={"Edit"}
              labelPlacement="start"
              sx={{
                justifyContent: "space-between",
                marginLeft: 0,
                marginRight: 0,
              }}
            />
          )}
        </BTBox>
      }
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: closeProfile,
        },
        edite && {
          name: "Save",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          disabled: loading,
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ].filter(Boolean)}>
      {edite ? (
        <Grid container spacing={1}>
          {formFields.map((field, index) => (
            <Grid size={field.gridsize} key={index}>
              {renderField(field)}
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }} container>
            <BTTypography variant={"button"} fontWeight={"bold"} color={"text"}>
              Personal details :
            </BTTypography>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Name&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.first_name} {userdata?.middle_name}{" "}
                  {userdata?.last_name}userdata?.
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Email&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_email}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Mobile.No&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_mo_no}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Role&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {
                    roles?.find(({ value }) => value === userdata?.u_type)
                      ?.label
                  }
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTTypography
                variant="button"
                fontWeight="medium"
                textTransform="capitalize">
                Access Control&nbsp;:&nbsp;
              </BTTypography>
              <BTBox
                width={"100%"}
                borderRadius={"sm"}
                display="flex"
                p={1}
                gap={1}
                flexWrap={"wrap"}>
                {userdata?.p_submit && (
                  <BTBadge
                    badgeContent={"Submissions"}
                    size="xs"
                    container
                    color="success"
                  />
                )}
                {userdata?.p_results && (
                  <BTBadge
                    badgeContent={"Results"}
                    size="xs"
                    container
                    color="success"
                  />
                )}
                {userdata?.p_replies && (
                  <BTBadge
                    badgeContent={"Replies"}
                    size="xs"
                    container
                    color="success"
                  />
                )}
                {userdata?.p_returns && (
                  <BTBadge
                    badgeContent={"Returns"}
                    size="xs"
                    container
                    color="success"
                  />
                )}
                {userdata?.p_billing && (
                  <BTBadge
                    badgeContent={"billing"}
                    size="xs"
                    container
                    color="success"
                  />
                )}
                {userdata?.p_reports && (
                  <BTBadge
                    badgeContent={"reports"}
                    size="xs"
                    container
                    color="success"
                  />
                )}
              </BTBox>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }} container height={"250px"}>
            <BTTypography variant={"button"} fontWeight={"bold"} color={"text"}>
              Companey details :
            </BTTypography>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Companey Name&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_name}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Address Line 1&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_addr_line1}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Address Line 2&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_addr_line2}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  City&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_city}-
                  {userdata?.u_profile?.cmp_pincode}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  State Code&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_state_code}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Phone Number&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_ph}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Email Address&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography variant="button" fontWeight="light">
                  {userdata?.u_profile?.cmp_email}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Gst Number&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography variant="button" fontWeight="light">
                  {userdata?.u_profile?.cmp_gst}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Gst Rate (%)&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_gst_rate}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Pan Number&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.cmp_pan}
                </BTTypography>
              </BTBox>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Bank name&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.bank_name}
                </BTTypography>
              </BTBox>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  A/C No.&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.bank_acc_no}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  Branch&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.bank_branch}
                </BTTypography>
              </BTBox>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <BTBox>
                <BTTypography
                  variant="button"
                  fontWeight="medium"
                  textTransform="capitalize">
                  IFSC&nbsp;:&nbsp;
                </BTTypography>
                <BTTypography
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize">
                  {userdata?.u_profile?.bank_ifsc_code}
                </BTTypography>
              </BTBox>
            </Grid>
          </Grid>
        </Grid>
      )}
    </BTDialogBox>
  );
};
export default Profile;
